import React from 'react'
import { useTheme } from '@emotion/react'
import { Typography, Divider } from './'
import clsx from 'clsx'

function SectionTitle({ children, color = 'medGray', dividerColor, size = 'lg', className, style }) {
    const theme = useTheme()
    const sizeSwitch = (titleSize) => {
        const fontSize = theme.fontSize
        switch (titleSize) {
            case 'xs':
                return fontSize?.xs
            case 'sm':
                return fontSize?.sm
            case 'md':
                return fontSize?.lg
            case 'lg':
                return fontSize?.['2xl']
            case 'xl':
                return fontSize?.['3xl']
            case 'xxl':
                return fontSize?.['4xl']
        }
    }
    return (
        //'flex items-center justify-center flex-wrap'
        <div
            style={style}
            className={clsx(
                'flex items-center justify-center flex-wrap section-title',
                className
            )}
        >
            <Divider className="basis-10 grow-0" height="md" color={dividerColor} />{' '}
            {/*  className="w-2/12 md:w-3/12 lg:w-1/5" */}
            <Typography
                className="py-4 px-2 grow-[two]"
                type="h3"
                fontWeight="Semi Bold"
                color={color}
                fontSize={sizeSwitch(size)}
            >
                {children}
            </Typography>
            <Divider className="basis-10 grow" height="md" color={dividerColor} />{' '}
            {/* className="w-5/12 md:w-7/12 lg:w-3/5" */}
        </div>
    )
}

export default SectionTitle
